angular
  .module('resources.Sport', ['ngResource'])
  .factory('Sport', ['$resource', function ($resource) {
    var resource = $resource('/api/sports/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      update: {
        method: 'PUT'
      },
      search: {
        method: 'GET',
        url: '/api/sports-search',
        isArray: true
      }
    });

    return resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Sport.js